import React from "react";
import { ADL_PATTERNS } from "@/lib/clinicalLibrary";
import { Zap } from "lucide-react";
import { toast } from "sonner";

/**
 * One-tap ADL quick-pattern bar. Applies a baseline to all six ADLs
 * (bathing, dressing, eating, mobility, toileting, transferring) so the RN
 * only has to tweak exceptions afterwards.
 */
export default function ADLQuickPattern({ onApply, testid = "adl-quick" }) {
  const apply = (pattern) => {
    onApply?.(pattern.values);
    toast.success(`Applied "${pattern.label}" to all ADLs ${pattern.emoji}`);
  };
  return (
    <div
      className="rounded-xl p-4 border border-[#B7CADA] bg-gradient-to-br from-[#E7F1FB] to-[#f4f6f1]"
      data-testid={testid}
    >
      <div className="flex items-center gap-2 mb-3">
        <Zap className="w-4 h-4 text-[#0A3D79]" />
        <div>
          <div className="font-display text-[14.5px] font-semibold text-[#0B1E3A]">Quick-set all six ADLs</div>
          <div className="text-[12.5px] text-[#3A5275]">Tap a pattern, then tweak the exceptions below. Defaults to 7 days/week.</div>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {ADL_PATTERNS.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => apply(p)}
            className="text-left bg-white border border-[#B7CADA] rounded-lg p-3 hover:border-[#0A3D79] hover:shadow-md transition"
            data-testid={`${testid}-${p.id}`}
          >
            <div className="text-[22px] leading-none mb-1">{p.emoji}</div>
            <div className="font-semibold text-[13px] text-[#0B1E3A]">{p.label}</div>
            <div className="text-[11.5px] text-[#3A5275] mt-0.5 leading-snug">{p.blurb}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
